export const SCHEMA_VERSION_KEY = 'QATALOG_STORE_SCHEMA';
export const SEARCH_CONTEXT_KEY = 'SEARCH_CONTEXT_KEY';
export const APPSTATE_CONTEXT_KEY = 'APPSTATE_CONTEXT_KEY';
export const NOTIFICATION_CONTEXT_KEY = 'NOTIFICATION_CONTEXT_KEY';
